module.exports = __webpack_public_path__ + "static/media/main_news_bg.19db894c.webp";